module.exports = __webpack_public_path__ + "static/media/b919fc0c.jpg";